import { HOST_URL } from '../../config'
import { HttpStatus } from '../../constants/http-status.enum'
import type { ApiResponse } from '../index'
import type { IClientUID } from '../clients'

export interface ISystemInfo {
    progMode: 0 | 1
    epoch: bigint
    uptime: bigint
    freeHeap: number
    ntc1: number
    ntc2: number
    ignoreH2oPiezo: boolean
    piezo1: number
    ignoreCo2Piezo: boolean
    piezo2: number
    iceSense: number
    rawIceSense: number
    liqLevDisabled: boolean
    oneLiqLev: boolean
    liqH: boolean
    liqL: boolean
    boilerEnabled: boolean
    boilerState: boolean
    compressorState: boolean
    pumpState: number
    fanEnabled: boolean
    fanState: boolean
    circPumpEnabled: boolean
    circPumpState: boolean
    compressorActiveTime: number
    compressorInactiveTime: number
    pumpActiveTime: number
    pumpInactiveTime: number
    boilerActiveTime: number
    boilerInactiveTime: number
    fanActiveTime: number
    fanInactiveTime: number
    circPumpActiveTime: number
    circPumpInactiveTime: number
    relSol1State: boolean
    relSol2State: boolean
    relSol3State: boolean
    relSol4State: boolean
    relSol5State: boolean
    relSol6State: boolean
    relSol7State: boolean
    relSol8State: boolean
    vdet: number
    iprop: number
}

export async function getClientSystemInfo(clientId: IClientUID): Promise<ApiResponse<ISystemInfo>> {
    const response = await fetch(`${HOST_URL}system-info`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ clientId }),
    })
    const result = (await response.json()) as ApiResponse<ISystemInfo>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}
